(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    document.querySelectorAll('.follow-lola__media-video[autoplay]').forEach(function (video) {
      video.pause();
      video.removeAttribute('autoplay');
    });
  }

  document.querySelectorAll('[data-follow-lola]').forEach(function (section) {
    initFollowParallax(section, prefersReducedMotion);
    initMobileCarousel(section);
    initResponsiveMedia(section);
  });

  // Lazy-loading pattern for the direct-URL background video: it sits
  // inertly inside a <template> tag (never parsed as live DOM, never
  // fetched) until this clones it into the real DOM on load. Same video
  // for day and night now — no theme-based swap here anymore, so this
  // just does a single, one-time insertion instead of watching for
  // theme changes.
  function initResponsiveMedia(section) {
    var mediaContainer = section.querySelector('[data-follow-lola-media]');
    if (!mediaContainer) return;

    var dayTemplate = mediaContainer.querySelector('template[data-follow-lola-media-theme="day"]');
    if (!dayTemplate) return;

    var fragment = dayTemplate.content.cloneNode(true);
    var wrapper = document.createElement('div');
    wrapper.style.display = 'contents';
    wrapper.appendChild(fragment);

    mediaContainer.insertBefore(wrapper, dayTemplate);

    var video = wrapper.querySelector('video');
    if (video) {
      // Cloning a <template> containing <video><source> doesn't always
      // trigger WebKit's resource selection algorithm for the new node —
      // some iOS Safari versions leave the element parked at
      // HAVE_NOTHING (no metadata, no first frame), which is exactly the
      // white frame + native play icon reported on iPhone. load() forces
      // Safari to (re)run source selection on this specific node.
      video.load();

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // If play() still fails after load() (Low Power Mode, Safari's
          // "Never Auto-Play" setting, or a plain race condition), retry
          // once the browser confirms at least one frame is ready.
          video.addEventListener('canplay', function onCanPlay() {
            video.removeEventListener('canplay', onCanPlay);
            video.play().catch(function () {
              /* Autoplay blocked persistently (e.g. a manual visitor
                 setting) — poster/native icon stays, expected in that
                 case. */
            });
          });
        });
      }
    }
  }

  function initFollowParallax(section, reducedMotion) {
    var photos = Array.prototype.slice.call(section.querySelectorAll('[data-follow-lola-photo]'));
    if (!photos.length) return;

    // Multiple parallax layers: each photo carries its own speed (set per
    // block in the theme editor), so they visibly drift at different rates
    // relative to one another while scrolling — not one single collage
    // moving as a flat unit.
    var items = photos.map(function (photo) {
      return {
        el: photo,
        speed: parseFloat(photo.getAttribute('data-parallax-speed')) || 0
      };
    });

    // On mobile the collage becomes a static in-flow grid (see CSS), where
    // scroll-linked transforms would fight the normal document flow — skip
    // the scroll listener there, the gentle CSS idle float still runs.
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (reducedMotion || isMobile) return;

    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        ticking = false;
        return;
      }

      // Progress of the section through the viewport, roughly -1 (just
      // entered from below) to 1 (about to leave at the top).
      var centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;

      items.forEach(function (item) {
        var translateY = centerOffset * item.speed * -1;
        item.el.style.setProperty('--follow-lola-parallax-y', translateY.toFixed(1) + 'px');
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // Mobile-only photo carousel: keeps the dot indicators in sync with
  // whichever slide is currently centered in the scroll-snap container,
  // and lets tapping a dot jump straight to its slide. Runs regardless of
  // viewport width — on desktop the collage isn't a scroll container, so
  // this is a harmless no-op there (nothing to observe/scroll).
  function initMobileCarousel(section) {
    var track = section.querySelector('[data-follow-lola-collage]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-follow-lola-photo]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-follow-lola-dot]'));
    if (!track || !slides.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    setActive(0);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = slides.indexOf(entry.target);
              if (index > -1) setActive(index);
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var target = slides[index];
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }
})();